import ExpandMoreIcon from 'site-theme/icons/_ExpandMore';
import ExpandLessIcon from 'site-theme/icons/_ExpandLess';
import ChevronRightIcon from 'site-theme/icons/_ChevronRight';

import { type IIconsProps } from '../../../Icon';

const megaMenuClasses = 'flex flex-col w-full';

const megaMenuButtonClasses = 'bg-white rounded-[10px] drop-shadow px-4 py-2 flex items-center gap-4';
const megaMenuButtonTextClasses = 'site-paragraph-xl font-bold text-left w-auto mdS:w-64';

const megaMenuItemClasses = 'flex flex-col gap-4 py-4 border-t border-site-neutrals-30';
const megaMenuItemNameClasses = 'site-paragraph-xl font-bold text-left flex items-center justify-between pr-4';

/**
 * MobileFlyoutMegaMenu Icon Props
 */

const megaMenuIconProps: IIconsProps = {
  bg: false,
  size: 'IconS',
  options: {
    className: 'fill-site-neutrals-800',
  },
};

/**
 * MobileFlyoutMegaMenu Theme
 */

const mobileFlyoutMegaMenuSiteTheme = {
  megaMenuButtonClasses,
  megaMenuButtonTextClasses,
  megaMenuClasses,
  megaMenuItemClasses,
  megaMenuItemNameClasses,

  megaMenuIconProps,
  ExpandMoreIcon,
  ExpandLessIcon,
  ChevronRightIcon,
};

/**
 * Exports
 */

export default mobileFlyoutMegaMenuSiteTheme;
